import { render, staticRenderFns } from "./VisitsList.vue?vue&type=template&id=42160d36&"
import script from "./VisitsList.ts?vue&type=script&lang=ts&"
export * from "./VisitsList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports